import { dateWithoutHour, isWeekend, intToDay, intToMonth, firstLetterCapital, getWeekNumber } from "../../functions";
import { AnnualUserPlanningTimeSlot } from "./AnnualUserPlanningTimeSlot";

export const AnnualUserPlanningDay = (props) => {
    const { datePlanning, timeSlots, selectedTimeSlots, isPublicHoliday } = props;

    function handleClickDate(val, ctrlKey) {
        props.onClickDate(val, ctrlKey);
    };

    function handleClickTimeSlots(tsId, ctrlKey) {
        props.onClickTimeSlots(...tsId, ctrlKey);
    };

    function isSelected(timeSlot) {
        return selectedTimeSlots.some(sel => timeSlot.id.includes(sel));
    };

    const mergedTimeSlots = () => {
        const mts = timeSlots?.map((timeSlot, i) => {
            return { 'id': [timeSlot.id], 'hour_type_id': timeSlot.hour_type_id, 'hour_type': timeSlot.hour_type, 'start_date': timeSlot.start_date, 'end_date': timeSlot.end_date, 'state': timeSlot.state };
        });
        let i = mts.length - 1;
        while (i > 0) {
            if (mts[i].hour_type.id === mts[i - 1].hour_type.id) {
                mts[i - 1].end_date = mts[i].end_date;
                mts[i - 1].id.push(...mts[i].id);
                mts.splice(i, 1);
            }
            i--;
        }
        return mts;
    };

    return (
        <div className="relative h-6 p-px border-b m-0 group">
            <div
                className={"absolute h-6 w-5 text-xxxs z-10 p-px bg-slate-100/10 place-items-center cursor-pointer group-hover:bg-slate-100 hover:shadow-sm " + (isPublicHoliday === true ? "text-red-500" : "text-slate-700")}
                onClick={(e => { e.preventDefault(); handleClickDate(datePlanning, e.ctrlKey) })}
                title={firstLetterCapital(intToDay(datePlanning.getDay())) + " " + datePlanning.toLocaleDateString().substring(0, 2) + " " + intToMonth(datePlanning.getMonth() + 1) + " (Sem. " + getWeekNumber(datePlanning) + ")"}
            >
                {intToDay(datePlanning.getDay()).slice(0, 1).toUpperCase() + " " + datePlanning.toLocaleDateString().substring(0, 2)}
            </div>
            <div className={"h-full flex text-center align-top p-px gap-px w-full " + (isWeekend(datePlanning) ? "bg-green-50" : "bg-white")}>
                {mergedTimeSlots().map((timeSlot, index) =>
                    <AnnualUserPlanningTimeSlot
                        key={index}
                        timeSlot={timeSlot}
                        date={dateWithoutHour(datePlanning)}
                        onClickTimeSlots={handleClickTimeSlots}
                        selected={isSelected(timeSlot)}
                    />
                )}
            </div>
        </div>
    );
};
